export default __webpack_public_path__ + "static/pool-4db6f7b80341455b117156af87869896.jpg";